import React, { useEffect } from "react";
import { Button, ButtonGroup, TextField } from "@livingdesign/react";
import Recipient from "../../../../../../../pages/v2/Recipient";
import QA from "../../../../../../../consts/QA";
import ModalLD3 from "../../../../../common/Modal/ModalLD3";

export const QA_ID_PREFIX = `${QA.PAGES.RECIPIENT}-SavedRecipientsCreateModal`;

function SavedRecipientsCreateModal({
  isOpen,
  onClose,
  title,
  subTitle,
  onCreate,
  id,
  filterName,
  setFilterName,
  confirmCreateClick
}) {
  
  // // Reset state when modal is closed
  // useEffect(() => {
  //   if (!isOpen) {
  //     // Clear form data when modal closes
  //     setFilterName('');
  //   }
  // }, [isOpen, setFilterName]);

  // // Enhanced close handler to ensure state is reset
  // const handleClose = () => {
  //   setFilterName(''); // Reset immediately
  //   onClose();
  // };

  return (
    <>
          <ModalLD3
              isOpen={isOpen}
              onClose={onClose}
              title={title}
              actions={
                  <div data-testid={`${QA_ID_PREFIX}-actions`}>
                      <ButtonGroup data-testid={`${QA_ID_PREFIX}-button-group`}>
                          <Button
                              variant="tertiary"
                              size="medium"
                              onClick={onClose}
                              data-testid={`${QA_ID_PREFIX}-cancel-button`}
                          >
                              Cancel
                          </Button>
                          <Button
                              variant="primary"
                              size="medium"
                              onClick={confirmCreateClick}
                              data-testid={`${QA_ID_PREFIX}-edit-button`}
                          >
                              Create
                          </Button>
                      </ButtonGroup>
                  </div>
              }
        size={"medium"}
        id={id}
        data-testid={`${QA_ID_PREFIX}-modal`}
      >
        {subTitle}
        {
          (
            <div style={{ marginTop: "16px" }} data-testid={`${QA_ID_PREFIX}-name-input-section`}>
                <div className='secondary-typo' style={{ marginBottom: "8px" }} data-testid={`${QA_ID_PREFIX}-required-note`}>*Required field</div>
                <TextField
                    label="Recipient list name*"
                    value={filterName}
                    onChange={e => {
                      console.log('recipient filter create modal filter name change', e.target.value)
                       setFilterName(e.target.value)
                      }
                    }
                    data-testid={`${QA_ID_PREFIX}-name-input`}
                />
            </div>
          )
        }
      </ModalLD3>
    </>
  );
}

export default SavedRecipientsCreateModal;